import Layout from "../layout/Layout";
import React, {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';
import Button from "@amzn/awsui-components-react/polaris/button";
import Flashbar from "@amzn/awsui-components-react/polaris/flashbar"
import Spinner from "@amzn/awsui-components-react/polaris/spinner";
import {
    MAP_PACK_VALIDATION_SUMMARY_TABLE_COLUMN_DEFINITIONS,
    MAP_PACK_VALIDATION_SUMMARY_TABLE_FILTER_PROPERTIES,
    MAP_PACK_VALIDATION_SUMMARY_TABLE_VISIBLE_CONTENT_OPTIONS,
    PAGE_SIZE_OPTIONS
} from "../../utils/mapReleaseDashboard/mapPackValidationSummaryTableConfig";
import ComplexFilterTable from "../offline-maps/ComplexFilterTable";
import {useMapReleaseStore} from "../../store/MapReleaseStore";
import {ButtonDropdown, ButtonDropdownProps} from "@amzn/awsui-components-react";
import ModalController from "../common/popup/ModalController";
import { downloadData } from "../../utils/tableConfig";


const MapReleaseDashboard = () => {
    const activeValidationDataFetchStatus = false;

    // Subscribe to all state in one selector to ensure proper reactivity
    const {
        fetchMapPackValidationSummary,
        invalidMapPackValidationSummary,
        mapPackValidationSummary: mapPackValidationData,
        mapPackValidationLoaded: isMapPackValidationLoaded,
        mapPackValidationHeaders: mapPackValidationTableDownloadHeaders,
        mapPackValidationSummaryTablePreferences,
        setMapPackValidationSummaryTablePreferences
    } = useMapReleaseStore();

    const handleRegionClick = (evt: CustomEvent<ButtonDropdownProps.ItemClickDetails>) => {
        const region = evt.detail.id;
        if (region) {
            fetchMapPackValidationSummary(region);
        }
    };

    const CustomFlashbar: React.FC = () => {
        return <Flashbar items={[
            {
                header: "Error",
                type: undefined,
                content: "Could not load map pack validation summary ",
                dismissible: false,
                dismissLabel: "Dismiss message",
                id: "message_1"
            }
        ]}/>;
    }

    useEffect(() => {
        fetchMapPackValidationSummary("NA");
    }, []); // Empty dependency array ensures the effect runs only once

    return (
        <Layout>
            <div>
                <ButtonDropdown
                    items={[{
                        text: "Options",
                        items: [
                            {text: "NA", id: "NA"},
                            {text: "FE", id: "FE"},
                            {text: "EU", id: "EU"},
                            {text: "IN", id: "IN"},
                        ]
                    }]}
                    ariaLabel="Map Actions"
                    onItemClick={handleRegionClick}
                    variant="primary"
                >Region</ButtonDropdown>
            </div>
            <br/>
            {invalidMapPackValidationSummary && isMapPackValidationLoaded ? ([<CustomFlashbar/>, <br/>])
                : (!isMapPackValidationLoaded ? ([
                        <Spinner size="large"/>,
                        <br/>, <br/>]
                ) : ([<ComplexFilterTable
                    itemList={mapPackValidationData}
                    columnDefinitions={MAP_PACK_VALIDATION_SUMMARY_TABLE_COLUMN_DEFINITIONS}
                    visibleContentOptions={MAP_PACK_VALIDATION_SUMMARY_TABLE_VISIBLE_CONTENT_OPTIONS}
                    fetchingData={activeValidationDataFetchStatus}
                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                    filterProperties={MAP_PACK_VALIDATION_SUMMARY_TABLE_FILTER_PROPERTIES}
                    preferences={mapPackValidationSummaryTablePreferences}
                    setPreferences={setMapPackValidationSummaryTablePreferences}
                    tableName={"Map Release Dashboard"}
                    reportLayout
                    tableDescription={
                        "Total PNF = on-zone + stem-in + stem-out. Net change = candidate − control; " +
                        "it does not count newly failing trips. Map totals use reported aggregates, which may omit missing station measurements; " +
                        "a lower total does not establish an improvement when station data is incomplete. " +
                        "Stations with increased total PNF counts included stations with all six PNF counters and a higher candidate total; " +
                        "no trip-count minimum applies. Missing PNF fields show n/a." +
                        " Latency change = (candidate - control) / control × 100. Positive is slower; negative is faster. " +
                        "P50/P99 compare Flexible Recosting client latency on paired requests, not SPS production latency. " +
                        "Missing latency or a zero control baseline shows N/A."
                    }
                />, <br/>, <Button
                    onClick={() => downloadData(mapPackValidationData, mapPackValidationTableDownloadHeaders, "map_pack_validation_summary")}>
                    Download
                </Button>, <br/>, <br/>, <br/>]))}
            <br/>
        </Layout>
    );
};

export default MapReleaseDashboard;